<script>
  export let devicesBeingUsed = [];
  export let deleteDevice = () => {};
  export let addDevice = () => {};

  let newDevice;
</script>

<div class="col table-responsive-sm" style="height: 300px; overflow: scroll;">
  <label for="newDevice" class="form-label">Kullandığı Cihazlar</label>
  <div class="d-flex flex-row justify-content-center">
    <input
      type="text"
      class="form-control text-center"
      placeholder="Cihaz Adı"
      bind:value={newDevice}
    />
  </div>
  <button
    on:click|preventDefault={addDevice(newDevice)}
    class="btn btn-success mt-2">Ekle</button
  >
  <table class="table-sm">
    <thead>
      <tr>
        <th class="w-100">Cihaz Adı</th>
        <th class="w-25">İşlemler</th>
      </tr>
    </thead>
    <tbody>
      {#each devicesBeingUsed as device}
        <tr>
          <td class="w-100"
            ><input
              type="text"
              class="form-control text-center"
              bind:value={device.device}
            />
          </td>
          <td class="w-25">
            <button
              on:click|preventDefault={deleteDevice(device._id)}
              class="btn btn-danger">Sil</button
            ></td
          >
        </tr>
      {/each}
    </tbody>
  </table>
</div>
